import React, { useEffect, useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import AjudaTooltip from '../components/AjudaTooltip';
import ModalConfirmacao from '../components/ModalConfirmacao';

function Servicos() {
  const [servicos, setServicos] = useState([]);
  const [form, setForm] = useState({ nome_servico: '', descricao_servico: '' });
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formEdicao, setFormEdicao] = useState({});
  const [filtroColuna, setFiltroColuna] = useState('nome_servico');
  const [filtroInput, setFiltroInput] = useState('');
  const [filtroAplicado, setFiltroAplicado] = useState('');
  const [confirmacao, setConfirmacao] = useState({ aberto: false, id: null, nome: '' });

  function pesquisar() { setFiltroAplicado(filtroInput); }

  async function carregarServicos() {
    const response = await api.get('/servicos');
    setServicos(response.data);
  }

  useEffect(() => { carregarServicos(); }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  }

  async function criarServico() {
    if (!form.nome_servico.trim()) { toast.error('Nome do serviço é obrigatório!'); return; }
    await api.post('/servicos', form);
    setForm({ nome_servico: '', descricao_servico: '' });
    setMostrarForm(false);
    carregarServicos();
    toast.success('Serviço cadastrado com sucesso!');
  }

  function iniciarEdicao(s) {
    setEditando(s.servicoid);
    setFormEdicao({ ...s });
  }

  async function salvarEdicao() {
    if (!formEdicao.nome_servico?.trim()) { toast.error('Nome do serviço é obrigatório!'); return; }
    await api.put(`/servicos/${editando}`, {
      nome_servico: formEdicao.nome_servico,
      descricao_servico: formEdicao.descricao_servico,
    });
    setEditando(null);
    carregarServicos();
    toast.success('Serviço atualizado com sucesso!');
  }

  async function deletarServico(id) {
    try {
      await api.delete(`/servicos/${id}`);
      carregarServicos();
      toast.success('Serviço removido com sucesso!');
    } catch {
      toast.error('Este serviço não pode ser excluído pois está vinculado a uma ou mais obras.', { duration: 5000 });
    }
  }

  async function confirmarDeletar() {
    await deletarServico(confirmacao.id);
    setConfirmacao({ aberto: false, id: null, nome: '' });
  }

  const servicosFiltrados = servicos.filter(s =>
    String(s[filtroColuna] || '').toLowerCase().includes(filtroAplicado.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <h2 style={{ margin: 0 }}>🔧 Tipos de Serviço</h2>
          <AjudaTooltip texto={`Cadastre aqui os tipos de serviço que seu escritório oferece.\n\nExemplos:\n• Execução de Obras\n• Projetos de Engenharia\n• Topografia\n\nNa tela de Obras, você seleciona o tipo e descreve o que será feito naquela obra.`} />
        </div>
        <button className="btn-primary" onClick={() => setMostrarForm(!mostrarForm)}>
          {mostrarForm ? 'Cancelar' : '+ Novo Tipo de Serviço'}
        </button>
      </div>

      {mostrarForm && (
        <div className="card">
          <h3>Novo Tipo de Serviço</h3>
          <input name="nome_servico" placeholder="Nome do serviço * (Ex: Execução de Obras)" value={form.nome_servico} onChange={handleChange} />
          <textarea name="descricao_servico" placeholder="Descrição (opcional)" value={form.descricao_servico} onChange={handleChange} rows={3} style={{ resize: 'vertical' }} />
          <button className="btn-primary" onClick={criarServico}>Salvar</button>
        </div>
      )}

      <div className="card">
        <h3>Tipos de Serviço Cadastrados</h3>

        <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
          <select value={filtroColuna} onChange={e => { setFiltroColuna(e.target.value); setFiltroInput(''); setFiltroAplicado(''); }} style={{ minWidth: 140, marginBottom: 0 }}>
            <option value="servicoid">Cód. Serviço</option>
            <option value="nome_servico">Nome</option>
            <option value="descricao_servico">Descrição</option>
          </select>
          <input placeholder="Pesquisar..." value={filtroInput} onChange={e => setFiltroInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && pesquisar()} style={{ flex: 1, marginBottom: 0 }} />
          <button className="btn-primary" onClick={pesquisar} style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>Pesquisar</button>
        </div>

        <table>
          <thead>
            <tr>
              <th>Cód. Serviço</th>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {servicosFiltrados.map((s) => (
              editando === s.servicoid ? (
                <tr key={s.servicoid} style={{ background: '#f0f7ff' }}>
                  <td data-label="Cód. Serviço">{s.servicoid}</td>
                  <td data-label="Nome"><input value={formEdicao.nome_servico} onChange={e => setFormEdicao({ ...formEdicao, nome_servico: e.target.value })} style={{ marginBottom: 0 }} /></td>
                  <td data-label="Descrição"><input value={formEdicao.descricao_servico || ''} onChange={e => setFormEdicao({ ...formEdicao, descricao_servico: e.target.value })} style={{ marginBottom: 0 }} /></td>
                  <td data-label="Ações">
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn-primary" style={{ fontSize: 12, padding: '5px 10px' }} onClick={salvarEdicao}>Salvar</button>
                      <button className="btn-secondary" style={{ fontSize: 12, padding: '5px 10px' }} onClick={() => setEditando(null)}>Cancelar</button>
                    </div>
                  </td>
                </tr>
              ) : (
                <tr key={s.servicoid}>
                  <td data-label="Cód. Serviço">{s.servicoid}</td>
                  <td data-label="Nome">{s.nome_servico}</td>
                  <td data-label="Descrição">{s.descricao_servico || '—'}</td>
                  <td data-label="Ações">
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn-secondary" style={{ fontSize: 12, padding: '5px 10px' }} onClick={() => iniciarEdicao(s)}>Editar</button>
                      <button className="btn-danger" style={{ fontSize: 12, padding: '5px 10px' }} onClick={() => setConfirmacao({ aberto: true, id: s.servicoid, nome: s.nome_servico })}>Deletar</button>
                    </div>
                  </td>
                </tr>
              )
            ))}
            {servicosFiltrados.length === 0 && (
              <tr><td colSpan={4} style={{ textAlign: 'center', color: '#999' }}>Nenhum serviço encontrado</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <ModalConfirmacao
        aberto={confirmacao.aberto}
        titulo="Excluir tipo de serviço"
        mensagem={`Tem certeza que deseja excluir o serviço "${confirmacao.nome}"? Esta ação não pode ser desfeita.`}
        onConfirmar={confirmarDeletar}
        onCancelar={() => setConfirmacao({ aberto: false, id: null, nome: '' })}
      />
    </div>
  );
}

export default Servicos;
